export default {"src":"/_next/static/media/thumb.fccb3ba9.svg","height":15,"width":13,"blurWidth":0,"blurHeight":0};